import { render, staticRenderFns } from "./PatentCertificateList.vue?vue&type=template&id=2085628e&"
import script from "./PatentCertificateList.vue?vue&type=script&lang=js&"
export * from "./PatentCertificateList.vue?vue&type=script&lang=js&"
import style0 from "./PatentCertificateList.vue?vue&type=style&index=0&id=2085628e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports